import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchDashboardReport, fetchRatingData, fetchTopIssue } from "../../actions/summary";
import PieChart from "../../components/common/dashboard12/piechart.js";
import { VectorMap } from "react-jvectormap";
import SparkLineBoxChart from "../common/dashboard12/lineChart";
import LinearProgress from "@mui/material/LinearProgress";
import moment from "moment";
import AccessPage from "../Shared/accessPage";
import CircularProgressBar from "../common/circularBar";
import Splinechart from "../common/dashboard_chart";
import { red } from "@mui/material/colors";
import Loader from "../Shared/loader";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import "react-circular-progressbar/dist/styles.css";
import SecurityHealthTracker from "../common/dashboard_chart";

const Dashboard = () => {
  const { orgid } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isModal, setModal] = useState('');
  const [graphTime, setGraphTime] = useState('');
  const [selectedValue, setSelectedValue] = useState("");
  const [isExcelReportModal, setExcelReportModal] = useState(false);
  const [selectedModules, setSelectedModules] = useState([]);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [isRatingCalculated, setIsRatingCalculated] = useState(null);
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  // Available modules organized by category
  const excelModules = {
    "Attack Surface": [
      { id: "high-risk-vulnerability", name: "Passive VA" },
      { id: "vulnerable-obsolete-technology", name: "Vulnerable Obsolete Technology" },
      { id: "dangling-subdomain", name: "Dangling Subdomain" },
      { id: "blacklisted-ips", name: "Blacklisted IPs" },
      { id: "digital-inventory", name: "IP Discovery" },
      { id: "application-security", name: "Application Security" },
      { id: "active-vulnerabilities", name: "Active Vulnerabilities" },
      { id: "vulnerable-ssl-certificate", name: "Vulnerable SSL Certificates" },
      { id: "invalid-spf-records", name: "SPF" },
      { id: "invalid-dmarc-records", name: "DMARC" },
    ],
    "Data Exposure": [
      { id: "cloud-bucket-details", name: "Cloud Bucket Details" },
      { id: "stolen-cred", name: "Stolen Credentials" },
      { id: "malware-cred", name: "Malware Credentials" },
      { id: "leaked-session", name: "Leaked Sessions" },
      { id: "leaked-code", name: "Leaked Code" },
      { id: "pastebin", name: "Pastebin" },
      { id: "personal-information-breach", name: "Personal Information Breach" },
      { id: "telegram-forum", name: "Telegram Forum" },
      { id: "dark-web-mention", name: "Dark Web Mention" },
      { id: "postman-monitoring", name: "Postman Monitoring" },
      { id: "vip-entities", name: "VIP Entities" },
      { id: "consolidated-risk-report", name: "Consolidated Risk Report" }
    ],
    ...(vendorId ? {} : {
      "Brand Security": [
        { id: "brand-mentions", name: "Brand Mentions" },
        { id: "mobile-apps", name: "Mobile Apps" },
        { id: "domain-squatting", name: "Lookalike" },
        { id: "fake-social-media", name: "Fake Social Media" }
      ]
    })
  };

  if (orgid) {
    sessionStorage.setItem('vendorId', orgid);
  } else {
    // console.warn removed
  }

  const showSpinner = () => {
    setLoading(true);
  };

  const hideSpinner = () => {
    setLoading(false);
  };

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const oid = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const hasClients = useSelector(state => {
    const clients = state?.summary?.clients;
    const localClient = state?.summary?.localClient;

    // Check if clients is an array and has items, or if localClient exists and is not empty
    return (Array.isArray(clients) && clients.length > 0) ||
      (localClient && Object.keys(localClient).length > 0);
  });

  useEffect(() => {
    if (typeof client?.ratingCalculated === "boolean") {
      setIsRatingCalculated(client.ratingCalculated);
    }
  }, [client]);

  useEffect(() => {
    const fetchRatingCalculated = async () => {
      if (!id) return;

      try {
        const session = localStorage.getItem("session");
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
        const response = await axios.get(`${API_URL}/customer/${id}`);
        const data = response?.data?.data;
        const details = Array.isArray(data) ? data[0] : data;

        if (details && typeof details.ratingCalculated === "boolean") {
          setIsRatingCalculated(details.ratingCalculated);
        }
      } catch (error) {
        // ignore and fallback to existing client data
      }
    };

    fetchRatingCalculated();
  }, [id]);

  useEffect(() => {
    var org = JSON.parse(localStorage.getItem('org'));

    if (org?.services) {
      const hasRequiredServices =
        org.services.includes('AttackSurface') ||
        org.services.includes('Data Exposure') ||
        org.services.includes('BrandSecurity');
      if(org.services.includes('ExecutiveMonitoring') && (!hasRequiredServices)) {
        console.log('redirecting to executive monitoring');
        window.location.href = '/executive-monitoring/issues';
      }
      else if (!hasRequiredServices && !window.location.pathname.includes('/vendor')) {
        console.log('redirecting to vendor');
        window.location.href = '/vendor';
      }
    }

    if (orgid) fetchDashboardReport(orgid, "all", dispatch);
    else fetchDashboardReport(id, "all", dispatch);
  }, [id]);

  let summary = useSelector((state) => state?.summary?.dashboardSummary);
  let summaryLoading = useSelector((state) => state?.summary?.loading);
  let ratingData = useSelector((state) => state?.summary?.ratingData);
  useEffect(() => {
    if (summary === null) {
      showSpinner();
    } else {
      hideSpinner(false);
    }
  }, [summary]);

  useEffect(() => {
    fetchRatingData(id, graphTime, dispatch);
  }, [id, graphTime]);

  const rating = ratingData?.totalScoreDashboard;

  let securityGraphValueASM = ratingData?.ratings?.map(
    (row) => row?.attackSurfaceSecurityImpact
  );
  let securityGraphValueData = ratingData?.ratings?.map(
    (row) => row?.darkWebSecurityImpact
  );
  let securityGraphValueBrand = ratingData?.ratings?.map(
    (row) => row?.brandSecuritySecurityImpact
  );
  let securityGraphDate = ratingData?.ratings?.map((row) =>
    moment(row?.createdAt).format("DD-MM-YYYY")
  );
  const valueResult = Math.floor(
    Number(rating?.attackSurfaceSecurityImpact) +
    Number(rating?.darkWebSecurityImpact) +
    Number(rating?.brandSecuritySecurityImpact)
  );

  let graphLabels = Object.keys(summary?.services || {}).map((key) => key);
  let graphValue = Object.keys(summary?.services || {}).map((key) => {
    return summary?.services[key];
  });

  let location = summary?.assetMap?.map((value) => value?.location);
  location = location?.filter(function (element) {
    return element !== undefined;
  });
  let counts = location?.reduce((acc, curr) => {
    if (curr) {
      const str = JSON.stringify(curr["country"]);
      acc[str] = (acc[str] || 0) + 1;
      return acc;
    } else return acc;
  }, {});

  const distinctLocationData = summary?.assetMap;

  const values = {

  };
  let ipArray = summary?.scanDetailArray?.scanDetails;

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }


  let orgName = "Brandsek";
  if (JSON.parse(localStorage.getItem("user"))) {
    orgName = JSON.parse(localStorage.getItem("user")).organisationId.orgName;
  }



  const downloadFileExecutive = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/pptxreport/${id}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}ExecutiveReport.pptx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const downloadFullReport = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/downloadSummaryReport/${id}?reportType=Full`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}FullReport.docx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const downloadExecutiveWordReport = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/downloadSummaryReport/${id}?reportType=executiveWordReport`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}ExecutiveWordReport.docx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const navigateToCustomReport = () => {
    // Navigate to custom report page with the necessary parameters
    window.open(`/custom-report/${id}`, '_blank');
  };

  const downloadSummaryReport = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/organisations/${id}/summary-report`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}-Summary-Report.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading summary report:', error);
      alert('Error downloading summary report. Please try again.');
    }
  };

  const generateReport = (v) => {
    if (v == "Full") {
      if (loading) {
        return false;
      }
      downloadFullReport()
    }
    if (v == "Executive") {
      downloadFileExecutive();
    }
    if (v == "ExecutiveWord") {
      downloadExecutiveWordReport();
    }
    if (v == "Summary") {
      downloadSummaryReport();
    }
    if (v == "Custom") {
      navigateToCustomReport();
    }
  };

  // Handler for Excel report modal
  const handleExcelReportModal = () => {
    setExcelReportModal(true);
  };

  // Handler for module selection
  const handleModuleSelection = (moduleId) => {
    setSelectedModules(prev => {
      if (prev.includes(moduleId)) {
        return prev.filter(id => id !== moduleId);
      } else {
        return [...prev, moduleId];
      }
    });
  };

  // Handler for category selection (select/deselect all in category)
  const handleCategorySelection = (categoryModules, isSelected) => {
    const moduleIds = categoryModules.map(module => module.id);
    setSelectedModules(prev => {
      if (isSelected) {
        // Remove all modules from this category
        return prev.filter(id => !moduleIds.includes(id));
      } else {
        // Add all modules from this category
        const newModules = moduleIds.filter(id => !prev.includes(id));
        return [...prev, ...newModules];
      }
    });
  };

  // Download selected Excel reports
  const downloadSelectedExcelReports = async () => {
    if (selectedModules.length === 0) {
      alert('Please select at least one module to download.');
      return;
    }

    try {
      setDownloadingExcel(true);
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

      const currentId = orgid || id;
      const includeParam = selectedModules.join(',');

      const response = await axios.get(
        `${API_URL}/selected-excel-reports/${currentId}?include=${includeParam}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}-Detailed-Data-Report.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Close modal and reset selections
      setExcelReportModal(false);
      setSelectedModules([]);
    } catch (error) {
      // console.error removed
      alert('Error downloading reports. Please try again.');
    } finally {
      setDownloadingExcel(false);
    }
  };

  const totalScore = rating?.attackSurfaceSecurityImpact + rating?.darkWebSecurityImpact + rating?.brandSecuritySecurityImpact || 1;

  const attackSurfacePercentage = ((rating?.attackSurfaceSecurityImpact || 0) / 500) * 100;
  const darkWebPercentage = ((rating?.darkWebSecurityImpact || 0) / 300) * 100;
  const brandSecurityPercentage = ((rating?.brandSecuritySecurityImpact || 0) / 100) * 100;

  return (
    <div className="container-fluid">
      {loading && <Loader />}
      <AccessPage></AccessPage>

      {!hasClients ? (
        <div className="card">
          <div className="body text-center" style={{ padding: "50px 0" }}>
            <h3 style={{ color: "white" }}>No Clients Found</h3>
            <p style={{ color: "#999", margin: "20px 0" }}>
              There are currently no clients in the system. Please add a client to get started.
            </p>
            <Link
              to="/clients"
              className="btn btn-primary"
              style={{
                padding: "10px 30px",
                borderRadius: "4px",
                fontWeight: "bold"
              }}
            >
              <i className="fa fa-plus mr-2"></i>
              Add New Client
            </Link>
          </div>
        </div>
      ) : (
        <>
          {(summaryLoading || loading) && (
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          )}

          {isRatingCalculated === false && (
            <div className="alert alert-info mt-3" role="alert">
              Your scan is in progress. Complete results will appear here once it's complete.
            </div>
          )}
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2 className="welcome-text mb-1" style={{ fontWeight: 600 }}>Welcome 👋 {orgName}</h2>
                {/* <h1 className="subHeadingWelcome mt-1">Dashboard</h1> */}
                <nav aria-label="breadcrumb" className="mt-1">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      {vendorId ? <>
                        <Link to="/vendor"
                          onClick={(() => {
                            sessionStorage.clear();
                          })}
                        >Vendor Assessment</Link>
                      </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                    </li>
                    {
                      vendorName ?
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                          style={{ color: "white" }}
                        >
                          {vendorName}
                        </li> : ''
                    }
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      Summary
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-md-6 col-sm-12 text-left hidden-xs">
                <div className="d-flex justify-content-end align-items-center" style={{ gap: "10px" }}>
                  <Box sx={{ width: 200 }}>
                    <FormControl fullWidth>
                      <Select
                        displayEmpty
                        renderValue={(value) =>
                          value === "" ? <em>Download Reports</em> : value
                        }
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ color: "black", fontWeight: "bold" }}
                        value={selectedValue}
                        onChange={(event) => generateReport(event.target.value)}
                      >
                        <MenuItem value="Full">Full Report</MenuItem>
                        <MenuItem value="Summary">Summary Report</MenuItem>
                        <MenuItem value="Executive">Executive Report</MenuItem>
                        <MenuItem value="ExecutiveWord">Executive Word Report</MenuItem>
                        <MenuItem value="Custom">Create Custom Report</MenuItem>
                        <MenuItem value="DetailedDataReport" onClick={handleExcelReportModal}>Detailed Data Report Excel</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-md-5">
              <div className="card">
                <div className="body" style={{ minHeight: "435px", padding: "20px" }}>
                  {/* Title */}
                  <h4 className="welcome-text">Overall Security Health Score <img src={require('../../assets/images/i_icon.png')} alt="arrow-down" className="img-fluid" /> </h4>
                  {/* Score and Progress */}
                  <div className="d-flex align-items-center mt-3">
                    <div style={{ flex: 1, margin: "24px 0px" }}>
                      <h2 style={{ fontSize: "42px", fontWeight: "bold", color: "#1A1A1A" }}>
                        {valueResult || 0} / 900
                      </h2>
                      {/* <span style={{ color: "green", fontWeight: "bold" }}>⬆ 32.1%</span> */}
                    </div>
                    <div className="circleBoxProgress">
                      <CircularProgressBar
                        progressValues={[
                          Math.round(attackSurfacePercentage),
                          Math.round(darkWebPercentage),
                          Math.round(brandSecurityPercentage)
                        ]}
                        colors={["#24AE5F", "#F7931A", "#FBD76D"]}
                        size={200}
                        strokeWidth={12}
                      />
                    </div>
                  </div>

                  <div className="row mt-4 text-left">
                    <div className="col-lg-12">
                      <div className="d-flex align-items-center">
                        <span className="switchFlowButtonAttackSurface"></span>
                        <span className="mr-5" style={{ color: "#4A4A4A" }}>Attack Surface</span>
                        <span style={{ fontWeight: "500", color: "#1A1A1A" }}>
                          {rating?.attackSurfaceSecurityImpact || 0} / 500
                        </span>
                      </div>
                      <div className="d-flex align-items-center mt-2">
                        <span className="switchFlowButtonDataExposure"></span>
                        <span className="mr-5" style={{ color: "#4A4A4A" }}>Data Exposure</span>
                        <span style={{ fontWeight: "500", color: "#1A1A1A" }}>
                          {rating?.darkWebSecurityImpact || 0} / 300
                        </span>
                      </div>
                      <div className="d-flex align-items-center mt-2">
                        <span className="switchFlowButtonBrandSecurity"></span>
                        <span className="mr-5" style={{ color: "#4A4A4A" }}>Brand Security</span>
                        <span style={{ fontWeight: "500", color: "#1A1A1A" }}>
                          {rating?.brandSecuritySecurityImpact || 0} / 100
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Industry Benchmark Score */}
                  {(rating?.id === "662a35449c6fa7b6d3a5b5db" ||
                    rating?.orgId === "662a35449c6fa7b6d3a5b5db") && (
                      <div className="text-center mt-4">
                        <hr />
                        <label style={{ fontSize: "14px", color: "#4A4A4A" }}>
                          Industry benchmark score: <strong>753</strong>
                        </label>
                      </div>
                    )}

                  <div className="text-center mg-75Text" style={{ color: "#97A8C8", fontSize: "15px" }}>
                    Optimize again to get your best score
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="body pb-0" style={{ minHeight: "435px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="welcome-text mb-0">Security Health Score Tracker <img src={require('../../assets/images/i_icon.png')} alt="arrow-down" className="img-fluid" /> </h6>
                    <select
                      className="form-control"
                      style={{ width: 'auto', backgroundColor: '#fff', color: 'white', border: '1px solid #444' }}
                      onChange={(e) => {
                        setGraphTime(e.target.value);
                      }}
                    >
                      <option value="">Select Date</option>
                      <option value="7days">Last 7 days</option>
                      <option value="1month">Last 30 days</option>
                      <option value="3months">Last 3 months</option>

                    </select>
                  </div>
                  <div>
                    {securityGraphValueASM && (
                      <SecurityHealthTracker
                        value={securityGraphValueASM}
                        data={securityGraphValueData}
                        brand={securityGraphValueBrand}
                        date={securityGraphDate}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card">
                <div className="body" style={{ minHeight: "435px" }}>
                  <h6 className="welcome-text">Top Issues</h6>
                  <div className="list-group">
                    {summary?.issueArray?.slice(0, 4)?.map((row, index) => (
                      <Link
                        key={`issue-${index}`}
                        to={row?.link}
                        className="list-group-item list-group-item-action list-group-item-newUpdate"
                        style={{ color: "white" }}
                      >
                        {row?.msg}
                      </Link>
                    ))}
                    {summary?.issueArray?.length >= 5 &&
                      (
                        <span className="text-center mt-3"
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex"
                          }}
                        >
                          <a
                            onClick={() => {
                              setModal('Form Wizard modal')
                            }}
                            style={{
                              float: "right",
                              color: "#fff",
                            }}
                            className="btn btn-primary"
                          >
                            <i
                              className="fa fa-file-excel-o"
                              style={{ color: "#fff" }}
                            ></i>{" "}
                            View All
                          </a>
                        </span>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
              {(() => {
                const org = JSON.parse(localStorage.getItem('org'));
                return org?.services?.includes('AttackSurface') && (
                  <div className="row clearfix">
                    <div className="col-sm-4">
                      <div className="card">
                        <div className="body pb-0" style={{ minHeight: "440px" }}>
                          <div>
                            <h4 className="welcome-text">Assets Count Trend  <img src={require('../../assets/images/i_icon.png')} alt="arrow-down" className="img-fluid" /> </h4>
                          </div>
                          {summary?.scanDetailArray && (
                            <SparkLineBoxChart
                              dates={summary?.scanDetailArray?.dates}
                              ipArray={ipArray}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-2">
                      <div className="card">
                        <div className="body" style={{ minHeight: "440px" }}>
                          <div>
                            <h6 className="welcome-text">Application Cloud<img src={require('../../assets/images/i_icon.png')} alt="arrow-down" className="img-fluid" /> </h6>
                          </div>
                          <div className="list-group">
                            {summary?.applicationCloud?.slice(0, 4).map((record, index) => (
                              <p
                                key={`app-cloud-${index}`}
                                className="list-group-item list-group-item-action list-group-item-newUpdate mb-0"
                                style={{ color: "white" }}
                              >
                                {record}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="card">
                        <div className="body" style={{ minHeight: "440px" }}>
                          <div>
                            <h4 className="welcome-text">Open Ports <img src={require('../../assets/images/i_icon.png')} alt="arrow-down" className="img-fluid" /> </h4>
                          </div>
                          <div className="mt-5 d-flex justify-content-center align-items-center">
                            {graphValue && graphValue.length > 0 && (
                              <PieChart series={graphValue} label={graphLabels} />
                            )}
                          </div>
                          <div className="d-flex flex-wrap justify-content-center align-items-center">
                            {graphLabels && graphLabels.map((label, index) => {
                              const colors = ['#1DBF73', '#FF9F0A', '#FB3B52', '#E2E0FF'];
                              const colorIndex = index % colors.length;

                              return (
                                <div key={index} className="d-flex align-items-center mt-0 mr-2">
                                  <span
                                    className="mr-1"
                                    style={{
                                      display: 'inline-block',
                                      width: '12px',
                                      height: '12px',
                                      borderRadius: '50%',
                                      backgroundColor: colors[colorIndex]
                                    }}
                                  ></span>
                                  <span className="mr-1" style={{ color: "#4A4A4A" }}>{label}</span>
                                  <span style={{ fontWeight: "500", color: "#1A1A1A" }}>
                                    {graphValue[index] || 0}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="card">
                        <div className="body" style={{ minHeight: "440px" }}>
                          <div>
                            <h6 className="welcome-text">Asset Graph <img src={require('../../assets/images/i_icon.png')} alt="arrow-down" className="img-fluid" /> </h6>
                          </div>
                          <div id="world-map-markers" className="jvector-map main-map">
                            <VectorMap
                              containerStyle={{
                                height: "340px",
                              }}
                              map={"world_mill"}
                              backgroundColor="transparent"
                              borderColor="#fff"
                              borderOpacity={0.25}
                              borderWidth={0}
                              color="#e6e6e6"
                              regionStyle={{ initial: { fill: "#6c757d" } }}
                              markerStyle={{
                                initial: {
                                  r: 5,
                                  fill: "#766CFF",
                                  "fill-opacity": 1,
                                  stroke: "#000",
                                  "stroke-width": 1,
                                  "stroke-opacity": 0.4,
                                },
                              }}
                              markers={distinctLocationData}
                              series={{
                                regions: [
                                  {
                                    values: values,
                                    attribute: "fill",
                                  },
                                ],
                              }}
                              hoverOpacity={null}
                              normalizeFunction="linear"
                              zoomOnScroll={false}
                              scaleColors={["#000000", "#000000"]}
                              selectedColor="#000000"
                              selectedRegions={[]}
                              enableZoom={false}
                              hoverColor="#fff"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>

          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row clearfix"></div>
            </div>
          </div>
          <div
            className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
              }`}
          >
            <div className="modal-dialog modal-lg" id="clientModal">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Top Issues
                  </h5>
                  <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setModal("")}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body pricing_page">
                  <div className="card">
                    <div className="body">
                      <div className="list-group">
                        {summary?.issueArray?.map((row, index) => (
                          <Link
                            key={`modal-issue-${index}`}
                            to={row?.link}
                            className="list-group-item list-group-item-action list-group-item-newUpdate"
                            style={{ color: "white" }}
                          >
                            {row?.msg}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Excel Reports Modal */}
          <div
            className={`modal fade ${isExcelReportModal ? "d-block show" : ""}`}
            style={{ backgroundColor: isExcelReportModal ? "rgba(0,0,0,0.5)" : "transparent" }}
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fa fa-file-excel-o mr-2"></i>
                    Select Detailed Data Reports
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => {
                      setExcelReportModal(false);
                      setSelectedModules([]);
                    }}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    {Object.entries(excelModules).map(([category, modules]) => {
                      const categorySelected = modules.every(module => selectedModules.includes(module.id));
                      const categorySomeSelected = modules.some(module => selectedModules.includes(module.id));

                      return (
                        <div key={category} className="col-md-4 mb-4">
                          <div className="card">
                            <div className="card-header" style={{ backgroundColor: "#f8f9fa" }}>
                              <div className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0" style={{ color: "#333", fontWeight: "bold" }}>{category}</h6>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={categorySelected}
                                    ref={input => {
                                      if (input) input.indeterminate = categorySomeSelected && !categorySelected;
                                    }}
                                    onChange={() => handleCategorySelection(modules, categorySelected)}
                                  />
                                  <label className="form-check-label" style={{ color: "#666", fontSize: "12px" }}>
                                    Select All
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="card-body" style={{ maxHeight: "300px", overflowY: "auto" }}>
                              {modules.map((module) => (
                                <div key={module.id} className="form-check mb-2">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={module.id}
                                    checked={selectedModules.includes(module.id)}
                                    onChange={() => handleModuleSelection(module.id)}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={module.id}
                                    style={{ color: "#333", fontSize: "14px" }}
                                  >
                                    {module.name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {selectedModules.length > 0 && (
                    <div className="alert alert-info mt-3">
                      <strong>Selected modules ({selectedModules.length}):</strong>
                      <div className="mt-2">
                        {selectedModules.map(moduleId => {
                          const module = Object.values(excelModules).flat().find(m => m.id === moduleId);
                          return (
                            <span key={moduleId} className="badge badge-primary mr-2 mb-1">
                              {module?.name}
                              <button
                                type="button"
                                className="btn-close btn-sm ml-2"
                                onClick={() => handleModuleSelection(moduleId)}
                                style={{
                                  background: "none",
                                  border: "none",
                                  color: "white",
                                  fontSize: "12px",
                                  marginLeft: "5px"
                                }}
                              >
                                ×
                              </button>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setExcelReportModal(false);
                      setSelectedModules([]);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={downloadSelectedExcelReports}
                    disabled={selectedModules.length === 0 || downloadingExcel}
                  >
                    {downloadingExcel ? (
                      <>
                        <i className="fa fa-spinner fa-spin mr-2"></i>
                        Downloading...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-download mr-2"></i>
                        Download Selected Reports ({selectedModules.length})
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Dashboard;
